import { render, staticRenderFns } from "./AddPaymentMethodComponent.vue?vue&type=template&id=1f8766d5"
import script from "./AddPaymentMethodComponent.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethodComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports